export const ProcessModule = {
	namespaced: true,

	state: {
		running: false
	},

	actions: {
		halt({
			state
		}) {
			state.running = false;
		},

		dispatch({
			state
		}, callback) {
			if (state.running == false) {
				state.running = true;
				callback.call(state);
			}
		}
	}
}